import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../Services/useAuth';

const RedirectionPage = () => {
  const navigate = useNavigate();
  const { getUser, isTokenExpired, token, setToken, setRole } = useAuth();

  useEffect(() => {
    const user = getUser();
    setRole('');
    if (!token || !user?.afm || isTokenExpired()) {
      setToken(null);
      navigate('/', { replace: true });
      return;
    }

    if (user.is_admin === 1) {
      navigate('/request-management');
    } else if (user.is_active !== 1) {
      navigate('/inactive-user');
    } else if (user.is_email_verified === 1) {
      navigate('/details-preview');
    } else {
      navigate('/email');
    }
  }, [token, getUser, isTokenExpired, navigate, setToken, setRole]);

  return <Typography>Γίνεται ανακατεύθυνση...</Typography>;
};

export default RedirectionPage;
